import { QueryClient } from '@tanstack/react-query';

// Single shared React Query client. Lives outside main.tsx so non-component
// code (auth store, account deletion) can clear cached data on logout —
// otherwise user A's cached feed/bookmarks/notifications would be served to
// user B logging in on the same browser.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
